import { AxisAlertInfo } from 'plugin-alerts-dashboard-channels/channelAlerts/types/axis'
import {
    getCriticalBgBlinkColor,
    getCriticalWidgetBorderColor
} from 'plugin-alerts-dashboard-channels/common/helpers/criticalColorHelper'
import { css, FlattenSimpleInterpolation } from 'styled-components'

const widgetResetDefault = css`
    z-index: 999;

    .widget-axis {
        background-color: inherit;

        > div {
            background: transparent;
        }

        ul {
            padding: 4px !important;
        }
    }

    .widget-footer {
        .btn-legend {
            background: transparent;
        }
    }
`

export const getWidgetStylesState = (state: AxisAlertInfo, theme: Theme): FlattenSimpleInterpolation => {
    const color = getCriticalWidgetBorderColor(state.criticality, theme)
    const bg = getCriticalBgBlinkColor(state.criticality, theme)

    if (state.normalized) return css``

    if (!state?.acknowledged) {
        return css`
            & {
                box-shadow: inset 0px 0px 0px 2px ${color};
                ${widgetResetDefault}
            }

            ::after {
                position: absolute;
                content: '';
                width: 100%;
                height: 100%;
                top: 0;
                left: 0;

                box-shadow: inset 0px 0px 0px 4px ${color};
                background-color: ${bg};
                animation: breath-animation 1.5s infinite alternate;
            }
        `
    }

    if (state?.acknowledged && !state?.resolved && !state?.falseAlert) {
        return css`
            & {
                box-shadow: inset 0px 0px 0px 2px ${color};
                ${widgetResetDefault}
            }
        `
    }

    return css``
}

export const getAxisStyle = (state: AxisAlertInfo, theme: Theme): FlattenSimpleInterpolation => {
    const color = getCriticalWidgetBorderColor(state.criticality, theme)
    const bg = getCriticalBgBlinkColor(state.criticality, theme)

    if (state.normalized) return css``

    if (!state?.acknowledged) {
        return css`
            ::after,
            ::before {
                position: absolute;
                content: '';
            }

            ::before {
                box-shadow: inset 0px 0px 0px 2px ${color};
            }

            ::after {
                box-shadow: inset 0px 0px 0px 3px ${color};
                background-color: ${bg};
                animation: breath-animation 1.5s infinite alternate;
            }
        `
    }

    if (state?.acknowledged && !state?.resolved && !state?.falseAlert) {
        return css`
            &::before {
                content: '';
                position: absolute;

                box-shadow: inset 0px 0px 0px 2px ${color};
            }
        `
    }

    return css``
}

export const channelSelectStyle = css`
    z-index: 999;

    .widget-content,
    .widget-footer,
    .widget-actions {
        pointer-events: none;
    }

    .widget-header,
    .widget-msg,
    .widget-content-container > :first-child {
        background-color: #aeaeae80;
    }

    .widget-axis {
        background-color: transparent;

        ul > div {
            background: var(--beam-surface--primary);
        }
    }

    .widget-content::before {
        content: '';
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: #aeaeae80;
        z-index: 999;
        top: 0;
        left: 0;
    }

    .widget-footer button {
        background-color: transparent;
    }
`
